import { ValidationError } from "../errors";
import { serializerExtensions, SerializerExtensions } from "../extensions";
import { Serializer } from "../serializer";

export const boolean: Serializer<boolean> & SerializerExtensions<boolean> = {
  serialize: (value) => value,
  deserialize: (raw) => {
    if (raw === null) throw new ValidationError("Expected boolean. Received null");
    if (raw === undefined) throw new ValidationError("Expected boolean. Received undefined");
    return Boolean(raw);
  },
  ...serializerExtensions(),
};

export const booleanString: Serializer<boolean> & SerializerExtensions<boolean> = {
  serialize: (value) => value.toString(),
  deserialize: (raw) => {
    if (raw === "false") return false;
    if (raw === "true") return true;
    else
      throw new ValidationError(
        `Input value must be either "true" or "false" string. Received: ${raw}`,
      );
  },
  ...serializerExtensions(),
};
